import React from 'react';
import { mapModifiers } from '@/utils/funtion';

export type IconName = 'chevron-down' | 'more' | 'burger' | 'fingerprint'
    | 'radial_chart'
    | 'object_chart'
    | 'stacked_bar'
    | 'stack_value'
    | 'line_chart'
    | 'bar_chart'
    | 'column_chart'
    | 'dual_axes'
    | 'area-graph'
    | 'pie-chart'
    | 'all'
    | 'indicator'
    | 'industry'
    | 'local'
    | 'article'
    | 'menu_about'
    | 'menu_service'
    | 'menu_chart'
    | 'menu_signal'
    | 'menu_marker'
    | 'menu_doc'
    | 'menu_calendar'
    | 'menu_home'
    | 'menu_user'
    | 'menu_cart'
    | 'menu_log'
    | 'newest'
    ;
export type IconSize = '12x12' | '13x13' | '14x14' | '15x15' | '16x16' | '17x17' | '18x18' | '19x19' | '20x20' | '21x21' | '22x22' | '23x23' | '24x24' | '25x25' | '26x26' | '28x28' | '30x30' | '32x32' | '36x36' | '40x40' | '50x50' | '60x60' | '70x70' | '80x80' | '120x120';

interface IconProps {
    iconName?: IconName;
    size?: IconSize;
    style?: React.CSSProperties;
    className?: string;
    component?: React.ReactNode;
    onClick?: () => void;
}

const Icon: React.FC<IconProps> = ({
    iconName, size = '20x20', style, onClick, className, component
}) => {
    if (component) {
        return React.cloneElement(component as React.ReactElement, {
            style,
            onClick,
            className: mapModifiers('a-icon', iconName, className)
        });
    }
    return (
        <i className={mapModifiers('a-icon', iconName, size, className)} style={style} onClick={onClick} />
    )
};

export default React.memo(Icon);
